/*jQuery('.mobile-doble-click').click(function(event){
  if(jQuery(window).width() < 992 ){
    event.preventDefault();
    if (!jQuery(this).hasClass('clicked')) {
        // Add a class on the first click
        jQuery(this).addClass('clicked');
    } else {
        var hrefValue = jQuery(this).attr('href');
        // Redirect on the second click
        window.location.href = hrefValue; // Replace with your target URL
    }
  }
})*/
$(document).ready(function() {
    // Check if the device is mobile and add the event listeners
    const $slider = $('#Product-Slider');
    const $videoSlides = $slider.find('.product-images__slide--video');

    // Display pause button on hover
    $videoSlides.find('video').hover(
      function() {
        // Show the controls (pause button)
        $(this).attr('controls', true);
      },
      function() {
        // Hide the controls (pause button)
        $(this).removeAttr('controls');
      }
    );
});

/* Auto-advance the value strip (text-with-icons) on mobile (June 2026) */
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 767) return;
  var track = document.querySelector('.text-with-icons.swipe-on-mobile .text-with-icons__inner');
  if (!track) return;
  var blocks = track.querySelectorAll('.text-with-icons__block');
  if (blocks.length < 2) return;
  var idx = 0;
  setInterval(function() {
    idx = (idx + 1) % blocks.length;
    var left = blocks[idx].offsetLeft - blocks[0].offsetLeft;
    track.scrollTo({ left: left, behavior: 'smooth' });
  }, 3000);
});

/* Close the mobile menu drawer when an in-page link (e.g. Info -> #footer) is tapped (June 2026) */
document.addEventListener('click', function(e) {
  var link = e.target.closest('#mobile-menu a[href]');
  if (!link) return;
  var toggle = document.querySelector('.mobile-toggle-wrapper');
  if (toggle && toggle.classList.contains('active')) {
    document.body.classList.remove('overflow-hidden');
    toggle.classList.remove('active');
    toggle.removeAttribute('open');
  }
});

/* Hide the leftover account/login link in the mobile menu footer (June 2026) */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.thb-mobile-account-link').forEach(function(el) {
    el.style.display = 'none';
  });
});
